// extracted by mini-css-extract-plugin
export var container = "CoCSection-module--container--1tgoP";
export var visible = "CoCSection-module--visible--1xHMA";
export var heading = "CoCSection-module--heading--3or_7";
export var FadeInUp = "CoCSection-module--FadeInUp--9CE3j";
export var codeList = "CoCSection-module--codeList--63OxH";
export var FadeInUpMobile = "CoCSection-module--FadeInUpMobile--6sV5G";
export var contents = "CoCSection-module--contents--2Flch";
export var FadeIn = "CoCSection-module--FadeIn--15kCO";
export var Shiny = "CoCSection-module--Shiny--317q3";